<template>
  <div grid-list-xs class="d-flex justify-center align-center my-10">
    <v-card class="card-radius card-shadow my-16" :class="cardWidth == 'another-card-width' ? 'another-card-width' : 'card-width'" elevation="0">
      <v-card-title
        primary-title
        class="dark-blue white--text title font-weight-medium px-10"
        >Berkas Pendaftaran</v-card-title
      >
      <v-container class="py-8">
        <div class="content px-5">
          <p class="font-weight-bold">
            Berkas yang perlu dipersiapkan sebelum melakukan pendaftaran:
          </p>
          <ul>
            <li>
              Scan Kartu Keluarga. Pendaftar dalam kota wajib melampirkan KK (JPEG, JPG, PNG minimal 1MB, maksimal 10MB)
            </li>
            <li>
              Scan Akte Kelahiran (JPEG, JPG, PNG minimal 1MB, maksimal 10MB)
            </li>
            <!-- <li>Fotocopy Raport Semester 5 yang sudah dilegalisir</li> -->
            <li>
              Scan Catatan Kesehatan asli dari dokter/puskesmas (JPEG, JPG, PNG
              minimal 1MB, maksimal 10MB)
            </li>
            <li>
              Pas foto formal berwarna dengan seragam sekolah asal (SMP/MTs), ukuran 3x4 dengan latar belakang bebas. (JPEG, JPG, PNG minimal 1MB, maksimal 10MB)
            </li>
            <li>
              Surat Keterangan Siswa Aktif atau Rapor Semester Akhir (JPEG,
              JPG, PNG minimal 1MB, maksimal 10MB)
            </li>
            <li>
              Form Kesanggupan menaati tata tertib. Download <a target="__blank" href="https://drive.google.com/file/d/1SQMWSLNFRRSuo9EcGb3vy0KQ9IAMr0o4/view?usp=sharing">di sini</a>.
            </li>

            <!-- <li>
                Hasil Karya Gambar atau Portofolio (bagi pendaftar jurusan
                Animasi dan DKV)
              </li> -->
          </ul>
          <!-- <p>Anda harus membawa berkas-berkas di bawah ini pada saat tes seleksi masuk</p>
            <ul>
              <li>Fotocopy Kartu Keluarga</li>
              <li>Fotocopy Akte Kelahiran</li>
              <li>Fotocopy Raport Semester 5 yang sudah dilegalisir</li>
              <li>Catatan Kesehatan asli dari dokter/puskesmas</li>
              <li>Pas Foto 3x4 background merah (4 lembar)</li>
              <li>Hasil Karya Gambar atau Portofolio (bagi pendaftar jurusan Animasi dan DKV)</li>
            </ul> -->

          <!-- <p class="pt-5">Semua berkas dimasukkan stofmap berkancing:</p>
            <ul>
              <li v-for="stofmap in stofmaps" :key="stofmap.major">
                <v-row>
                  <v-col cols="6" sm="5" md="5" lg="4" class="py-0 pr-0">{{
                    stofmap.major
                  }}</v-col>
                  <v-col class="py-0">: {{ stofmap.color }}</v-col>
                </v-row>
              </li>
            </ul> -->
        </div>
      </v-container>
    </v-card>
  </div>
</template>

<script>
export default {
  name: "BerkasPendaftaran",
  props: ["cardWidth"],
  data: () => ({
    stofmaps: [
      { major: "DKV Konsentrasi Teknik Grafika", color: "Hijau" },
      { major: "DKV Konsentrasi Desain Grafika", color: "Biru" },
      { major: "Animasi 3D", color: "Merah" },
      { major: "Animasi 2D", color: "Putih" },
      { major: "Pengembangan Perangkat Lunak dan Gim", color: "Kuning" },
    ],
  }),
};
</script>


<style scoped>
.dark-blue {
  background-color: #24305e !important;
}

.card-text {
  font-size: 1.2rem;
}

.card-radius {
  border-radius: 10px !important;
}

.card-width {
  width: 60%;
}

.another-card-width {
  width: 85%;
}

.card-shadow {
  box-shadow: -2px -2px 4px rgba(0, 0, 0, 0.08), 2px 2px 4px rgba(0, 0, 0, 0.08) !important;
}

.berkas-section {
  min-height: 80vh;
}

@media screen and (max-width: 600px) {
  .card-width {
    width: 90%;
  }
}
</style>